import { render, staticRenderFns } from "./BindAttribute.vue?vue&type=template&id=3429191a&scoped=true"
import script from "./BindAttribute.vue?vue&type=script&lang=js"
export * from "./BindAttribute.vue?vue&type=script&lang=js"
import style0 from "./BindAttribute.vue?vue&type=style&index=0&id=3429191a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429191a",
  null
  
)

export default component.exports